export class BatchUpdate<T> {
	constructor(public data: T) {}
}
